import { Box, IconButton, Paper, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { PendingOrderAdditionalFee, PendingOrderProduct, PreviewOrder } from '../../services/orders';
import { SimpleList } from '../../components/SimpleList';
import { translateUOM } from '../../i18n/utils';
import { CURRENCY_SYMBOLS, Currencies, QuickOrderProduct } from '../../types';
import { QuickOrderSellerTotals } from '../orders/components/OrderPaymentTotals';
import { CloudDownload as CloudDownloadIcon } from '@mui/icons-material';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

export const CheckoutOrderProducts = ({orderInfo, products, additionalFees, orderIdx, onQuantityIncrease, onQuantityDecrease}: {orderInfo: PreviewOrder, products: PendingOrderProduct[], additionalFees: PendingOrderAdditionalFee[], orderIdx?: number, onQuantityIncrease?: (productId: number) => void, onQuantityDecrease?: (productId: number) => void}) => {
	const {t} = useTranslation();
	return (
		<div key={orderInfo?.id}>
			<Paper sx={{p: 2, background: 'none'}} elevation={0} variant='outlined'>
				<Box display='flex' flexDirection='row' gap={1} justifyContent='space-between' mb={2}>
					<div>
						<Typography variant='body2' color='primary.main'>
							{t('checkout.seller')} {orderIdx !== undefined ? `#${orderIdx + 1}` : ''}
						</Typography>
						<Typography>
							{[orderInfo.vendorName, orderInfo.vendorTaxId].filter(Boolean).join(', ')}
						</Typography>
						<Typography>
							{orderInfo.vendorAddress}
						</Typography>
					</div>
					<Typography variant='body2' mt={1}>
						{t('checkout.productsCount', { count: products.length })}
					</Typography>
				</Box>
				<SimpleList items={products.map((product) => ({
					imgUrl: product.imgUrl,
					label: product.name,
					secondary: `${CURRENCY_SYMBOLS[orderInfo.currency as Currencies]}${product.pricePerUnit}`,
					properties: [...((product as QuickOrderProduct).digitalDelivery ? [{
						el: <Tooltip title='Digital delivery'><CloudDownloadIcon color='success' /></Tooltip>,
					}] : []), {
						label: product.quantity,
						secondary: translateUOM(product.uom),
					}, ...(onQuantityIncrease && onQuantityDecrease ? [{
						el: <Box display='flex' alignItems='center' gap={1} flexDirection='column'>
							<IconButton size='small' onClick={() => onQuantityIncrease?.(product.id)}><ArrowDropUpIcon /></IconButton>
							<IconButton size='small' onClick={() => onQuantityDecrease?.(product.id)}><ArrowDropDownIcon /></IconButton>
						</Box>
					}] : [])]
				}))} />
				<QuickOrderSellerTotals 
					products={products}
					additionalFees={additionalFees}
					currency={orderInfo.currency}
				/>
			</Paper>
		</div>
	);
};

